import React, {Component} from "react";
import {connect} from "react-redux";

import * as componentTypes from "../../constants/componentTypes";
import * as navigationActions from "../../actions/navigationActions";

import ProgressBarModalComponent from "../../components/apps/default/modal/ProgressBarModal";

class ProgressBarModal extends Component {
    render() {
        return (
            <ProgressBarModalComponent
                id={this.props.id}
                downloadingFileList={this.props.downloadingFileList}
                downloadingFileListRcc={this.props.downloadingFileListRcc}
                closeProgressBarModal={this.props.dispatchCloseProgressModalAction}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        downloadingFileList: store.server.downloadingFileList,
        downloadingFileListRcc: store.rcc.downloadingFileList
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseProgressModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.PROGRESS_BAR_MODAL));
        }
    };
};

export default ProgressBarModal = connect(mapStoreToProps, mapDispatchToProps)(ProgressBarModal);
